import { styled } from 'solid-styled-components';
import { Button, H1, LoaderIcon, Text } from '../../../../components';

export const ActionModalStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 8px;
`;

export const H1Styled = styled(H1)`
    margin-top: 16px;
`;

export const TextStyled = styled(Text)`
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    max-width: 250px;
    margin-top: 10px;
    color: ${props => props.theme!.colors.text.contrast};
`;

export const LoaderButtonStyled = styled(Button)`
    min-width: 112px;
    margin-top: 32px;
`;
export const LoaderIconStyled = styled(LoaderIcon)`
    height: 16px;
    width: 16px;
`;

export const ButtonStyled = styled.div`
    margin-top: 24px;
  background-color: ${props => props.theme!.colors.text.primary};
  height: 48px;
  width: 262px;
  justify-content: center;
  border-radius: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
